import styled from 'react-emotion'

import { colours, spacers } from '../theme'
import { colourContrast } from '../utils'

const Panel = styled('div')`
  background: ${props => (props.colour ? props.colour : colours.dark )};
  color: ${props => (props.colour ? colourContrast(props.colour) : colourContrast(colours.dark))};
  padding: ${spacers['7']} 0;
  margin: 60px 0;
  h1, h2, h3, h4, h5, h6 {
    color: ${props => (props.colour ? colourContrast(props.colour) : colourContrast(colours.dark))}!important;
  }
`

export default Panel
